import { ServiceProvider } from '../services/ServiceProvider';
import { FindInvoiceUseCase } from './FindInvoiceUseCase';
import { ProcessPaymentUseCase } from './ProcessPaymentUseCase';
import { FindRecordatorioUseCase } from './FindRecordatorioUseCase';

/**
 * Proveedor de casos de uso para la capa de aplicación
 */
export class UseCaseProvider {
  /**
   * Obtiene una instancia del caso de uso para buscar facturas
   * @returns Instancia del caso de uso para buscar facturas
   */
  public static getFindInvoiceUseCase(): FindInvoiceUseCase {
    const invoiceService = ServiceProvider.getInvoiceService();
    return new FindInvoiceUseCase(invoiceService);
  }

  /**
   * Obtiene una instancia del caso de uso para procesar pagos
   * @returns Instancia del caso de uso para procesar pagos
   */
  public static getProcessPaymentUseCase(): ProcessPaymentUseCase {
    const paymentService = ServiceProvider.getPaymentService();
    const invoiceService = ServiceProvider.getInvoiceService();
    return new ProcessPaymentUseCase(paymentService, invoiceService);
  }

  /**
   * Obtiene una instancia del caso de uso para buscar recordatorios de pago
   * @returns Instancia del caso de uso para buscar recordatorios
   */
  public static getFindRecordatorioUseCase(): FindRecordatorioUseCase {
    const recordatorioService = ServiceProvider.getRecordatorioService();
    return new FindRecordatorioUseCase(recordatorioService);
  }
} 